import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/axios';
import logo from '../../assets/Venzo-Logo.png.webp';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', type: '' });
    const [emailSent, setEmailSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setAlert({ show: false, message: '', type: '' });
        setLoading(true);

        try {
            await api.post('/users/forgot-password', { email });
            setLoading(false);
            setEmailSent(true);
            setAlert({
                show: true,
                message: 'Password reset instructions have been sent to your email.',
                type: 'success'
            });
        } catch (err) {
            console.error('Forgot password error:', err);
            setLoading(false);
            setAlert({
                show: true,
                message: err?.response?.data?.message || 'Failed to send reset email. Please try again.',
                type: 'error'
            });
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0 16px'
        }}>
            {/* Status bar space */}
            <div style={{ height: 32 }} />

            {/* Logo */}
            <img src={logo} alt="Venzo Logo"
                style={{ width: 90, margin: '12px auto 16px auto', display: 'block' }}
            />

            {/* Alert message */}
            {alert.show && (
                <div style={{
                    marginBottom: 18,
                    background: alert.type === 'success' ? '#e3ffe8' : '#ffe1e1',
                    color: alert.type === 'success' ? '#187439' : '#b30000',
                    padding: "10px 15px",
                    borderRadius: 7,
                    fontSize: 15,
                    fontWeight: 500,
                    border: alert.type === 'success' ? '1.2px solid #94e7b1' : '1.2px solid #fbbebe',
                    width: '100%',
                    maxWidth: 340,
                    textAlign: 'center'
                }}>{alert.message}</div>
            )}

            {/* Forgot Password box */}
            <form
                onSubmit={handleSubmit}
                style={{
                    width: '100%',
                    maxWidth: 350,
                    background: 'transparent',
                    margin: '0 auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <h1 style={{
                    fontWeight: 700,
                    fontSize: 28,
                    marginBottom: 6,
                    marginTop: 0,
                    color: '#222'
                }}>
                    Forgot Password?
                </h1>
                <div style={{
                    color: '#667085',
                    marginBottom: 22,
                    fontSize: 16
                }}>
                    {emailSent
                        ? "Check your email for reset instructions"
                        : "Enter your email and we'll send you reset instructions"
                    }
                </div>

                {!emailSent && (
                    <>
                        {/* Email field */}
                        <label style={{
                            fontWeight: 500,
                            fontSize: 13,
                            letterSpacing: 1,
                            color: '#333',
                            marginBottom: 4
                        }}>
                            EMAIL
                        </label>
                        <div style={{ position: 'relative', marginBottom: 22 }}>
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                                style={{
                                    width: '100%',
                                    padding: '13px 40px 13px 12px',
                                    border: '1.5px solid #e1e1e1',
                                    borderRadius: 6,
                                    fontSize: 16,
                                    outline: 'none',
                                    background: '#fff'
                                }}
                                autoFocus
                                disabled={loading}
                                placeholder="your@email.com"
                            />
                            {email && (
                                <span style={{
                                    position: 'absolute',
                                    right: 12,
                                    top: 13,
                                    color: 'green',
                                    fontSize: 18
                                }}>
                                    &#10003;
                                </span>
                            )}
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                width: '100%',
                                padding: '14px',
                                background: loading ? '#ccc' : '#000',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 6,
                                fontSize: 16,
                                fontWeight: 600,
                                cursor: loading ? 'not-allowed' : 'pointer',
                                marginBottom: 16
                            }}
                        >
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>
                    </>
                )}

                {/* Back to Login */}
                <div style={{ textAlign: 'center', marginTop: emailSent ? 0 : 8 }}>
                    <button
                        type="button"
                        onClick={() => navigate('/login')}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#007bff',
                            fontSize: 15,
                            fontWeight: 500,
                            cursor: 'pointer',
                            textDecoration: 'none',
                            padding: '8px 0'
                        }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    >
                        ← Back to Login
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ForgotPasswordPage;
